/*@ngInject*/
const UIZipCodeFormatterDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm, $attrs, ngModelController) {

        function runFormat() {
            if (ngModelController.$viewValue.toString().length === 9) {
                ngModelController.$viewValue = _.replace(ngModelController.$viewValue.toString(), '-', '');
                ngModelController.$viewValue = ngModelController.$viewValue.toString().slice(0, 5) + '-' + ngModelController.$viewValue.toString().slice(5);
                ngModelController.$render();
            } else if (ngModelController.$viewValue.toString().length === 5) {
                ngModelController.$viewValue = ngModelController.$viewValue.toString();
                ngModelController.$render();
            }
        }

        function handleBlur() {
            runFormat();
        }

        $($elm).on('blur', handleBlur);

        $scope.$on('$destroy', function () {
            $($elm).off('blur', handleBlur);
        });

        $timeout(function () {
            if (!_.isEmpty(ngModelController.$modelValue)) {
                runFormat();
            }
        }, 300);
    };

    return {
        restrict: 'A',
        link: linkFunction,
        require: 'ngModel'
    };
};

angular.module('umCore')
    .directive('uiZipCodeFormatter', UIZipCodeFormatterDirective);
